import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

/** Public marketing contact — no auth header required */
const ProductInquiryService = {
  sendProductInquiry: async (payload) => {
    const response = await axios.post(
      `${API_URL}/PublicInquiry/SendProductInquiry`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  },
};

export default ProductInquiryService;
